import { ProgressiveBarService } from './../../shared/progressive-bar/progressive-bar.service';
import { Switch } from './../../shared/switch.interface';
import { Plate } from './../../shared/plate.interface';
import { CoverConfiguratorService } from './cover-configurator.service';
import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { WebcallsService } from 'src/app/webcalls.service';
import { DataproviderService } from 'src/app/dataprovider.service';

@Component({
  selector: "app-cover-configurator",
  templateUrl: "./cover-configurator.component.html",
  styleUrls: [
    "./cover-configurator.component.scss",
    "./cover-configurator.responsive.scss"
  ],
  host: {
    class: "configurator-container bg-standard"
  }
})
export class CoverConfiguratorComponent implements OnInit {
  title: string = "b2c.IDS_COVERCONFIGURATOR";
  subtitle: string = "b2c.IDS_COVERCONFIGURATOR_SUB";
  question: string = "b2c.IDS_COVERCONFIGURATOR_QUE";
  activePage: string = "coverconfigurator";
  nextPage: string = "times";
  dataEntries: any = [];

  plates: Plate[] = null;
  switches: Switch[] = null;
  selectedPlate: Plate = null;
  selectedSwitch: Switch = null;
  plateUrl: string;
  switchesUrl: string;

  eventCategory: string = "IDS_GTAG_CATEGORY";
  eventLabel: string = "";

  constructor(
    private cs: CommonService,
    private ws: WebcallsService,
    public ds: DataproviderService,
    private confService: CoverConfiguratorService,
    private progressiveBarService: ProgressiveBarService,
  ) {
    this.cs.setParams(this.title, this.subtitle, this.question, this.activePage, this.nextPage, true, true, false, true, 'configurator',false,false,this.eventCategory,this.eventLabel);
    this.progressiveBarService.setProgressiveBarLengthByPageIndex(9);
  }

  ngOnInit() {
    let cachedData = this.ds.getCachedCoverConfiguratorData();
    this.cs.setEventAction(undefined);
    if (!cachedData) {
      this.wsCall();
    } else {
      this.initConfigurator(cachedData);
    }
    if(this.ds.getShapeID()){
      this.eventLabel="IDS_COVERCONFIGURATOR_SHAPE_".concat(this.ds.getShapeID().toString()).concat("_TECHNOLOGY_".concat(this.ds.getTechnologyID().toString()));
    }else{
      this.eventLabel="IDS_COVERCONFIGURATOR".concat("_TECHNOLOGY_".concat(this.ds.getTechnologyID().toString())).concat("_FINISHING").concat(this.ds.getFinishingID().toString());
    }
    this.cs.setLabelEvent(this.eventLabel);
  }

  wsCall() {
    this.ws
      .getCoverConfiguratorData(
        this.ds.getLocalizationID()
      )
      .subscribe(data => {
        this.initConfigurator(data);
      });
  }

  initConfigurator(data) {
    let activeData = data[this.ds.getFinishing().name_ref];
    if (this.ds.getShape()) {
      this.plates = activeData.plates.filter(p => {
        return p.Shape.toLocaleLowerCase() == this.ds.getShape().name_ref;
      });
    } else {
      this.plates = activeData.plates;
    }
    this.switches = activeData.switches;
    this.initConfiguratorPlate();
    this.initConfiguratorSwitch();
  }

  initConfiguratorPlate() {
    let selectedSerie = this.plates.find(s => s.ID === this.ds.getSerieID());
    if (!selectedSerie) {
      selectedSerie = this.plates.find(s => s.Default);
    }
    this.selectedPlate = selectedSerie ? selectedSerie : this.plates[0];
    this.ds.setSerie(this.selectedPlate);
    this.updatePlateImageUrl();
  }

  initConfiguratorSwitch() {
    let selectedSwitch = this.switches.find(s => s.id === this.ds.getSwitchID());
    if (!selectedSwitch) {
      selectedSwitch = this.switches.find(s => s.default);
    }
    this.selectedSwitch = selectedSwitch ? selectedSwitch : this.switches[0];
    this.ds.setSwitch(this.selectedSwitch);
    this.updateSwitchImageUrl();
  }

  updatePlateImageUrl() {
    if (this.selectedPlate && this.selectedPlate.Code3) {
      this.plateUrl = this.confService.getPlateUrl(this.selectedPlate.Code3);
    } else {
      this.plateUrl = undefined;
    }
  }

  updateSwitchImageUrl() {
    if (this.selectedSwitch) {
      this.switchesUrl = this.confService.getSwitchUrl(this.selectedSwitch.id, 3);
    } else {
      this.switchesUrl = undefined;
    }
  }

  getSelectedPlateIdx() {
    let plate = this.plates.find(s => {
      return s.ID == this.selectedPlate.ID;
    });
    return this.plates.indexOf(plate);
  }

  onPlateUp() {
    const currentPlateIdx = this.getSelectedPlateIdx();
    if (currentPlateIdx !== -1 && currentPlateIdx < this.plates.length - 1) {
      this.selectedPlate = this.plates[currentPlateIdx + 1];
      this.updatePlateImageUrl();
      this.ds.setSerie(this.selectedPlate);
    } else if (currentPlateIdx == (this.plates.length - 1)){
      this.selectedPlate = this.plates[0];
      this.updatePlateImageUrl();
      this.ds.setSerie(this.selectedPlate);
    }
  }

  onPlateDown() {
    const currentPlateIdx = this.getSelectedPlateIdx();
    if (currentPlateIdx !== -1 && currentPlateIdx > 0) {
      this.selectedPlate = this.plates[currentPlateIdx - 1];
      this.updatePlateImageUrl();
      this.ds.setSerie(this.selectedPlate);
    } else if (currentPlateIdx == 0){
      this.selectedPlate = this.plates[this.plates.length - 1];
      this.updatePlateImageUrl();
      this.ds.setSerie(this.selectedPlate);
    }
  }

  getSelectedSwitchIdx() {
    let cSwitch = this.switches.find(s => {
      return s.id == this.selectedSwitch.id;
    });
    return this.switches.indexOf(cSwitch);
  }

  onSwitchUp() {
    const currentSwitchIdx = this.getSelectedSwitchIdx();
    if (this.ds.getFinishingID() == 2){
      this.selectedSwitch = this.switches[0];
      this.updateSwitchImageUrl();
      this.ds.setSwitch(this.selectedSwitch);
    } else if (currentSwitchIdx !== -1 && currentSwitchIdx < this.switches.length - 1) {
      this.selectedSwitch = this.switches[currentSwitchIdx + 1];
      this.updateSwitchImageUrl();
      this.ds.setSwitch(this.selectedSwitch);
    } else if (currentSwitchIdx == (this.switches.length - 1)) {
      // continue from the beginning
      this.selectedSwitch = this.switches[0];
      this.updateSwitchImageUrl();
      this.ds.setSwitch(this.selectedSwitch);
    }
  }

  onSwitchDown() {
    const currentSwitchIdx = this.getSelectedSwitchIdx();
    if (this.ds.getFinishingID() == 2){
      this.selectedSwitch = this.switches[0];
      this.updateSwitchImageUrl();
      this.ds.setSwitch(this.selectedSwitch);
    } else if (currentSwitchIdx !== -1 && currentSwitchIdx > 0) {
      this.selectedSwitch = this.switches[currentSwitchIdx - 1];
      this.updateSwitchImageUrl();
      this.ds.setSwitch(this.selectedSwitch);
    } else if (currentSwitchIdx == 0) {
      // select from the last
      this.selectedSwitch = this.switches[this.switches.length - 1];
      this.updateSwitchImageUrl();
      this.ds.setSwitch(this.selectedSwitch);
    }
  }
}
